import { z } from 'zod';

export const RegisterInputSchema = z.object({
    name: z.string().nonempty("Jméno musí být vyplněno").min(3, "Jméno musí mít minimálně 3 znaky"),
    surname: z.string().nonempty("Příjmení musí být vyplněno"),
    email: z.string().nonempty("E-mail musí být vyplněn").email("Musíte zadat platný email"),
    password: z.string().nonempty("Heslo nesmí být prázdné").min(8, "Heslo musí mít minimálně 8 znaků").max(30, "Heslo může mít maximálně 30 znaků"),
    confirm_tos: z.boolean().refine(val => val === true, {
        message: "Musíte souhlasit se zpracováváním osobních údajů",
    }),
    confirm_rules: z.boolean().refine(val => val === true, {
        message: "Musíte souhlasit s pravidlami komunity",
    }),});

export type TRegisterInput = z.infer<typeof RegisterInputSchema>;
export type TRegister = {
    email: string
    password: string;
    name: string;
    surname: string;
    from_ref_id: string | null;
}
